import React, { useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { BsInfoCircle, BsCodeSquare } from 'react-icons/bs';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const Project = ({ info, className }) => {
	const { pathname: pathName } = useLocation();
	const [showCode] = useState(pathName === '/portfolio/admin');

	const { imgUrl, title, liveUrl, infoUrl, githubUrl, type } = info;

	return (
		<Card
			className={`${
				className || ''
			} project-card__${type} transition duration-300 hover:shadow-lg   hover:border hover:border-primary-main`}
			variant='outlined'
		>
			{/* <div className=""> */}
			<div className='p-4 pb-0'>
				<div className='w-full pb-2/3 relative top-0 left-0 overflow-hidden  border border-solid border-gray-300 rounded'>
					<CardMedia
						className='absolute top-0 left-0 right-0'
						component='img'
						alt='React Logo'
						image={imgUrl}
					/>
				</div>
			</div>
			<CardContent>
				<Typography component='h4' variant='h6' align='center'>
					{title}
				</Typography>

				{/* <Typography variant="body1">{description}</Typography> */}
			</CardContent>
			<CardActions className='justify-center flex-wrap space-x-2 mb-4 pt-0'>
				<Button
					variant='outlined'
					href={infoUrl}
					target='_blank'
					startIcon={<BsInfoCircle />}
					size='small'
				>
					info
				</Button>

				<Button
					variant='contained'
					href={liveUrl}
					target='_blank'
					startIcon={<FaEye />}
					size='small'
				>
					preview
				</Button>
				{showCode && (
					<Button
						startIcon={<BsCodeSquare />}
						variant='outlined'
						href={githubUrl}
						target='_blank'
						size='small'
					>
						code
					</Button>
				)}
			</CardActions>
		</Card>
	);
};

Project.propTypes = {
	className: PropTypes.string,
	info: PropTypes.object,
};

export default Project;
